import { FeatureDetector } from '@eyeson/js';

const inIframe = FeatureDetector.inIframe();
const isSafari = FeatureDetector.isSafari();
const isMobileDevice = FeatureDetector.hasMobileDevice();

const minimumChromiumVersion = (minimumVersion) => {
  return (
    Reflect.has(navigator, 'userAgentData') &&
    navigator.userAgentData.brands.some(
      ({ brand, version }) =>
        brand === 'Chromium' && Number(version) >= minimumVersion
    )
  );
};

const checkAutoPip = () => {
  try {
    navigator.mediaSession.setActionHandler('enterpictureinpicture', null);
  } catch (_error) {
    return false;
  }
  return true;
};

const supports = {
  ClipboardAPI:
    !!navigator.clipboard &&
    typeof navigator.clipboard.writeText === 'function' &&
    !inIframe,
  KeyboardLockAPI:
    !!navigator.keyboard &&
    typeof navigator.keyboard.lock === 'function' &&
    !inIframe,
  PiPConferenceControls:
    navigator.mediaSession &&
    typeof navigator.mediaSession.setCameraActive === 'function',
  playCanvasStreamBug: isSafari && FeatureDetector.browserVersion() < 16,
  YoutubePopup:
    FeatureDetector.canScreenCapture &&
    navigator.mediaDevices &&
    navigator.mediaDevices.getSupportedConstraints &&
    navigator.mediaDevices.getSupportedConstraints()
      .suppressLocalAudioPlayback === true &&
    Reflect.has(window, 'CaptureController') &&
    Reflect.has(window, 'URLPattern'),
  AutoPip:
    navigator.mediaSession &&
    typeof navigator.mediaSession.setCameraActive === 'function' &&
    minimumChromiumVersion(124) &&
    !FeatureDetector.isPhone() &&
    checkAutoPip(),
  SecondCamera: !isMobileDevice,
};

export default supports;
